import axios from "axios";
import { useEffect, useState } from "react";
import { BookingStat } from "../types/types";

import { useIntl } from "react-intl";
import moment from "moment";
import { bookingStatMessages } from "../messages";
import { IConfig, useConfig } from "../../../lib/config";
import { useKeycloakAuthz } from "../../../components/keycloak-provider";

const formatNumber = number => {
  return number % 1 === 0 ? number : number.toFixed(2);
};

const getPercentage = ({ today, yesterday }: any) => {
  if (today === 0 || yesterday === 0) return 0;
  const percentage = ((today - yesterday) / yesterday) * 100;
  return formatNumber(percentage);
};

const getMonthsFromToday = (date: Date) => {
  const today = moment(new Date());
  const dateToCompare = moment(date);
  return dateToCompare.diff(today, "months");
};

export const useGetBookingStat = ({ propertyTicker }: { propertyTicker: string }) => {
  const [bookingStat, setBookingStat] = useState<any | undefined>([]);
  const [data, setData] = useState<any | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  const configuration: IConfig = useConfig();
  const intl = useIntl();
  const keycloak = useKeycloakAuthz()

  useEffect(() => {
    if (data) {
      const newData = [
        {
          title: intl.formatMessage(bookingStatMessages.sales),
          tooltip: intl.formatMessage(bookingStatMessages.tooltipGeneral),
          value: data.bookingsMadeCurrentYear,
          difference: getPercentage({
            today: data.bookingsMadeCurrentYear,
            yesterday: data.bookingsMadePastYear,
          }),
          showSymbol: true,
        },
        {
          title: intl.formatMessage(bookingStatMessages.cancellations),
          tooltip: intl.formatMessage(bookingStatMessages.tooltipGeneral),
          value: data.cancellationsMadeCurrentYear,
          negativeValueIsPositive: true,
          difference: getPercentage({
            today: data.cancellationsMadeCurrentYear,
            yesterday: data.cancellationsMadePastYear,
          }),
          showSymbol: true,
        },
        {
          title: intl.formatMessage(bookingStatMessages.averageStay),
          tooltip: intl.formatMessage(bookingStatMessages.tooltipGeneral),
          value: data.avgStayInDaysCurrentYear,
          difference: getPercentage({
            today: data.avgStayInDaysCurrentYear,
            yesterday: data.avgStayInDaysPastYear,
          }),
          showSymbol: true,
        },
        {
          title: intl.formatMessage(bookingStatMessages.reserveHorizont),
          tooltip: intl.formatMessage(bookingStatMessages.tooltipReserveHorizont),
          value: moment(data.horizonDate).utc().format("DD/MM/YYYY"),
          difference: getMonthsFromToday(data.horizonDate),
          sign: intl.formatMessage(bookingStatMessages.months),
        },
      ];
      setBookingStat(newData);
      setLoading(false);
    }
  }, [intl, data]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`${configuration.bookingStatUrl}/${propertyTicker}`, {
          headers: {
            Authorization: keycloak.rpt,
          }
        });
        const responseData: BookingStat = data;
        setData(responseData || []);
      } catch (error) {
        setLoading(false);
        console.log("Error in booking stat", error);
      }
    };
    fetchData();
  }, [configuration.bookingStatUrl, propertyTicker, keycloak]);

  return { data: bookingStat, loading };
};
